import './App.css';
import Footer from './components/Footer';
import Header from './components/Header';
import MainSection from './components/MainSection';
import Section2 from './components/Section2';
import { useState } from 'react';
import Search from './components/Search';

const  App = () => {
  const [show, setShow] = useState(true);
  return (
    <>
   <Header setShow={setShow} show={show}/>
   {show && <MainSection />}
   {show && <Section2 />}
   {show ? "" : <Search />}
  <Footer />
    </> 
  );
}

export default App;
